import React from 'react'
import type { TextProps } from '@vtex/admin-ui'
import { csx } from '@vtex/admin-ui'

import { DeliveryChannel, ShippingMethod } from '../../../../constants'
import type { Package } from '../../../../../../core/typings'

export type ChangeMethodLabelProps = TextProps & {
  selectedShippingMethod: ShippingMethod
  currentPackage: Package
}

export const ChangeMethodLabel = ({
  children,
  currentPackage,
  selectedShippingMethod,
  ...props
}: ChangeMethodLabelProps) => {
  const isPickupSelected =
    currentPackage.selectedSlaType === DeliveryChannel.PickupInPoint &&
    selectedShippingMethod === ShippingMethod.PickUp

  if (selectedShippingMethod === ShippingMethod.Customize || isPickupSelected) {
    return (
      <span
        className={csx({
          display: 'inline-block',
          color: '$blue40',
          cursor: 'pointer',
          paddingTop: '$space-2',
          marginBottom: '$space-6',
          fontWeight: '500',
        })}
        {...props}
      >
        {children}
      </span>
    )
  }

  return null
}
